import { render, staticRenderFns } from "./ZDMLightingControl.vue?vue&type=template&id=45579980&"
import script from "./ZDMLightingControl.vue?vue&type=script&lang=js&"
export * from "./ZDMLightingControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports